import { Injectable } from "@angular/core";
import { Router, NavigationStart } from "@angular/router";
//import { Observable, Subject } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { AppGlobals } from "../app.globals";

@Injectable({ providedIn: "root" })
export class AlertService {
    //private subject = new Subject<any>();
    //private keepAfterNavigationChange = false;

    constructor(private router: Router, private toasterService: ToastrService, private appGlobals: AppGlobals) {
        // clear alert message on route change
        //router.events.subscribe(event => {
        //    if (event instanceof NavigationStart) {
        //        if (this.keepAfterNavigationChange) {
        //            // only keep for a single location change
        //            this.keepAfterNavigationChange = false;
        //        } else {
        //            // clear alert
        //            this.subject.next();
        //        }
        //    }
        //});
    }

    showMessage(content, title, style, timeout?) {
        //this.keepAfterNavigationChange = keepAfterNavigationChange;

        if (style === this.appGlobals.alertMessageTypes.success)
            this.toasterService.success(content, title, { timeOut: timeout ? timeout : 3000});

        if (style === this.appGlobals.alertMessageTypes.error)
            this.toasterService.error(content, title, { timeOut: timeout ? timeout :5000 });

        if (style === this.appGlobals.alertMessageTypes.warning)
            this.toasterService.warning(content, title, { timeOut: timeout ? timeout :3000 });

        if (style === this.appGlobals.alertMessageTypes.info)
            this.toasterService.info(content, title, { timeOut: timeout ? timeout :3000 });
    }

    //success(message: string, keepAfterNavigationChange = false) {
    //    this.keepAfterNavigationChange = keepAfterNavigationChange;
    //    this.subject.next({ type: "success", text: message });
    //}

    //warning(message: string, keepAfterNavigationChange = false) {
    //    this.keepAfterNavigationChange = keepAfterNavigationChange;
    //    this.subject.next({ type: "warning", text: message });
    //}

    //error(message: any, keepAfterNavigationChange = false) {
    //    this.keepAfterNavigationChange = keepAfterNavigationChange;
    //    this.subject.next({ type: "error", text: message.message });
    //}

    //getMessage(): Observable<any> {
    //    return this.subject.asObservable();
    //}
}